import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, CmsConfig, ConfigModule, OccConfig } from '@spartacus/core';
import { CustomStatisticDisplayComponent } from './components/custom-statistic-display/custom-statistic-display.component';
import { UigCustomStatisticGuard } from './uig-custom-statistic.guard';

@NgModule({
  declarations: [
    CustomStatisticDisplayComponent,
],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            statisticPdf: '/myrio/statistic/pdf',
          },
        },
      },
    } as OccConfig),
    ConfigModule.withConfig({
      cmsComponents: {
        StatisticComponent: {
          component: CustomStatisticDisplayComponent,
          guards :[AuthGuard ,UigCustomStatisticGuard]
         },
      }
    } as CmsConfig),

  ]
})
export class CustomStatisticModule { }
